import request from '@/utils/request';
const baseInvoice = process.env.VUE_APP_INVOICE;
const baseURLAdmin = process.env.VUE_APP_ADMIN; // admin

// mdfe分页查询
export const getMDfePage = (data) => {
  return request({
    method: 'POST',
    url: '/invoice/mdfe/mdfePage',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取公司选项
export const getCompanyOptions = (data) => {
  return request({
    method: 'POST',
    url: '/invoice/mdfe/companyPage',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取司机分页信息
export const getDriverPage = (data) => {
  return request({
    method: 'POST',
    url: '/invoice/mdfe/driverPage',
    data,
    baseURL: baseURLAdmin
  });
};
// 根据车牌号获取车辆信息
export const getCarInfoByPlateNumber = (data) => {
  return request({
    method: 'get',
    url: '/invoice/mdfe/getCarByLicensePlate?licensePlate=' + data,
    baseURL: baseURLAdmin
  });
};
// 校验车签号
export const checkCarSign = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/checkVtag',
    data,
    baseURL: baseInvoice
  });
};
// 取消MDFE
export const cancelMdfe = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/cancel',
    data,
    baseURL: baseInvoice
  });
};
// 生成MDFE
export const createMdfe = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/generate',
    data,
    baseURL: baseInvoice
  });
};
// 关闭MDFE
export const closeMdfeApi = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/close',
    data,
    baseURL: baseInvoice
  });
};
// 根据mdfe查询关联的cte
export const getCteByMdfe = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/getCteByMdfe',
    data,
    baseURL: baseURLAdmin
  });
};
// 通过mdfe查询关联司机
export const getDriverByMdfe = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/getDriverByMdfe',
    data,
    baseURL: baseURLAdmin
  });
};
// 解析mdfe xml 信息
export const parseMdfeXml = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/getMdfe',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取cte发票分页数据
export const getCteInvoicePage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 导出CTE发票
export const exportCteInvoice = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 根据CTE发票密钥获取CTE发票信息
export const getCteInvoiceByKey = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/getCteByInvoiceKeys',
    data,
    baseURL: baseURLAdmin
  });
};
// 按业务单号或发票号导出
export const exportCteInvoiceByNumbers = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/exportByNumbers',
    data,
    baseURL: baseURLAdmin,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 获取中途州省信息
const baseURL1 = process.env.VUE_APP_ADDRESS;
export const getMidProvince = (data) => {
  return request({
    method: 'get',
    url: '/addressSelector/v1/states?countryCode=076',
    data,
    baseURL: baseURL1
  });
};
// 通过州获取城市
export const getMidCity = (data) => {
  return request({
    method: 'get',
    url: '/addressSelector/v1/getCityListByState/' + data,
    baseURL: baseURL1
  });
};
// MDFE操作日志
export const getMdfeOperationLog = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfeLog/mdfeLogPage',
    data,
    baseURL: baseURLAdmin
  });
};
// 取消cte发票
import requestZipCode from '@/utils/zipcodeRequest';
export const cancelCteInvoice = (data, isBool = true) => {
  return requestZipCode({
    method: 'post',
    url: '/cte/cancel',
    data,
    baseURL: baseInvoice,
    isLoading: isBool
  });
};
// 补开cte发票
export const reopenCteInvoice = (data, isBool = true) => {
  return requestZipCode({
    method: 'post',
    url: '/cte/supplement',
    data,
    baseURL: baseInvoice,
    isLoading: isBool
  });
};
// CTE绑定批单号失败分页
export const getCteBindBatchFailPage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteBindAverError/page',
    data,
    baseURL: baseURLAdmin
  });
};
// CTE绑定批单号
export const bindCteBatch = (data) => {
  return request({
    method: 'post',
    url: '/cte/bindAver',
    data,
    baseURL: baseInvoice
  });
};
// 强制关闭
export const forceCloseCteInvoice = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/forceClose',
    data,
    baseURL: baseInvoice
  });
};
// CTE自动创建失败分页
export const getCteAutoCreateFailPage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteErrorLog/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 下载cte xml
export const downloadCteXml = (data) => {
  return request({
    method: 'get',
    url: '/invoice/cte/getCteXmlByInvoiceKey/' + data,
    data,
    baseURL: baseURLAdmin
  });
};
// 重新生成cte
export const reGenerateCte = (data) => {
  return request({
    method: 'get',
    url: '/cte/cteMqErrorLogHandle?id=' + data,
    baseURL: baseInvoice
  });
};
// 导出NFSe发票
export const exportNFSeInvoiceApi = (data) => {
  return request({
    method: 'post',
    url: '/invoice/NFSe/exportAll',
    data,
    baseURL: baseURLAdmin,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 新开CTE发票
export const newOpenCteInvoice = (data) => {
  return requestZipCode({
    method: 'post',
    url: '/cte/generate',
    data,
    baseURL: baseInvoice
  });
};
// cnpj 查询
export const getCnpjInfo = (data) => {
  return request({
    method: 'post',
    data,
    url: '/invoice/cnpj/pageQuery',
    baseURL: baseURLAdmin
  });
};
// 更新cnpj信息
export const updateCnpjInfo = (data) => {
  return request({
    method: 'post',
    data,
    url: '/invoice/cnpj/updateCnpjInfo',
    baseURL: baseURLAdmin
  });
};
// 获取最新信息
export const getNewestCnpjInfo = (data) => {
  return request({
    method: 'get',
    url: '/invoice/cnpj/gainLatestInfo/' + data,
    baseURL: baseURLAdmin
  });
};
// 下载xml
export const downloadXmlApi = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/getMdfeXmlByMdfeKey/' + data,
    data,
    baseURL: baseURLAdmin
  });
};
// nfse数据核对-快递-分页查询
export const getNfseDataCheckPage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/receivingInvoices/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// nfse数据核对-揽收-分页查询
export const getNfseCollectCheckPage = (data) => {
  return request({
    method: 'post',
    url: '/invoice/collectOrderInvoice/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 快递订单数据推送批量导出
export const exportNfseDataCheck = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cteErrorLog/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 获取CTE开票日历趋势图
export const getCteInvoiceTrend = (data) => {
  return request({
    method: 'get',
    url: '/invoice/cte/dayCount?month=' + data,
    baseURL: baseURLAdmin
  });
};
// 批量导入重新生成
export const batchReGenerate = (data) => {
  return request({
    method: 'post',
    url: '/cte/importExcelHandle',
    data,
    baseURL: baseInvoice,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};
// 剔除重复包裹记录-分页查询
export const getRepeatPackagePage = (data) => {
  return request({
    method: 'post',
    url: '/tagBagRemoveRecord/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 剔除重复包裹记录-导出
export const exportRepeatPackage = (data) => {
  return request({
    method: 'post',
    url: '/tagBagRemoveRecord/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 车签号校验
export const checkTagNumber = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/checkVtagForRemoveBag',
    data,
    baseURL: baseInvoice
  });
};
// 查询重复数据列表
export const getRepeatPackageList = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/listRepeatPackage',
    data,
    baseURL: baseInvoice
  });
};
// 剔除重复包裹记录
export const removeRepeatPackage = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/removeVTagRepeatPackage',
    data,
    baseURL: baseInvoice
  });
};
// 重复率查询
export const getRepeatRate = () => {
  return request({
    method: 'get',
    url: '/tagBagRepeatRateSet/getOne',
    baseURL: baseInvoice
  });
};
// 修改重复率
export const updateRepeatRate = (data) => {
  return request({
    method: 'post',
    url: '/tagBagRepeatRateSet/add',
    data,
    baseURL: baseInvoice
  });
};
// 获取批量下载CTE发票信息
export const getBatchDownloadCteInvoiceInfo = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cte/getCteBatchDownload',
    data,
    baseURL: baseURLAdmin
  });
};
// 异常处理MDFE
export const handleMdfeException = (data) => {
  return request({
    method: 'post',
    url: '/mdfe/abnormalMdfeHand',
    data,
    baseURL: baseInvoice
  });
};
// 客户开票主体配置--分页查询
export const getInvoiceSubjectPage = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfo/pageQuery',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置--新增或者编辑
export const addOrUpdateInvoiceSubject = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfo/saveOrUpdate',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置--导出
export const exportInvoiceSubject = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfo/export',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置操作日志--导出
export const exportInvoiceSubjectLog = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfoOperateLog/export',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置--操作日志分页查询
export const getInvoiceSubjectLogPage = (data) => {
  return request({
    method: 'post',
    url: '/cteCustomerBasicInfoOperateLog/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 客户开票主体配置--启用/禁用
export const enableInvoiceSubject = (data) => {
  return request({
    method: 'get',
    url: '/cteCustomerBasicInfo/updateStatus?id=' + data.id + '&status=' + data.status,
    baseURL: baseURLAdmin
  });
};
// 获取客户开票主体配置详情
export const getInvoiceSubjectDetail = (data) => {
  return request({
    method: 'get',
    url: '/cteCustomerBasicInfo/getById?id=' + data,
    baseURL: baseURLAdmin
  });
};
// 通过cnpj、州二字码获取相关信息
export const getInvoiceSubjectByCnpj = (data) => {
  return request({
    method: 'post',
    url: '/cte/getIeByCnpj',
    data,
    baseURL: baseInvoice
  });
};
// 通过邮编获取地址信息
export const getAddressByZipCode = (data) => {
  return request({
    method: 'post',
    url: '/invoice/cep/getCepInfo',
    data,
    baseURL: baseURLAdmin
  });
};
// mdfe批量导出
export const exportMdfeBatch = (data) => {
  return request({
    method: 'post',
    url: '/invoice/mdfe/exportAll',
    data,
    baseURL: baseURLAdmin
  });
};
